<template>
  <div>
    <default-bar />
    <default-drawer />

    <default-view />
  </div>
</template>

<script>

export default {
  name: "DefaultLayout",

  components: {
    DefaultBar: () =>
      import(
        /* webpackChunkName: "default-app-bar" */
        "./AppBar"
      ),
    DefaultDrawer: () =>
      import(
        /* webpackChunkName: "default-drawer" */
        "./Drawer"
      ),

    DefaultView: () =>
      import(
        /* webpackChunkName: "default-view" */
        "./View"
      ),
  },
  data: () => ({
    isLogin: false,
  }),
  mounted() {
    if (localStorage.getItem("user") || false) {
      this.isLogin = true;
    }
  },
  computed: {},
};
</script>
